import type { MenuProps } from '@mui/material';

/**
 * Where a row menu opens (N1, D-92). The table's menu keeps the desktop's
 * 40 px drop under the row's top edge. A card's opens from its kebab: under
 * the button, into the card. With the table's offset it hung ~50-60 px below
 * the trigger, over the card's values, and a long menu ran past the bottom of
 * the viewport: the popover fits the paper to the viewport without knowing
 * about the transform.
 *
 * One placement for every card's row menu: the data grid's cards and the
 * table-as-cards pages (task manager, clinical meetings).
 */
export type RowMenuPlacement = 'row' | 'card';

const ROW_MENU: Partial<MenuProps> = {
  style: { transform: 'translateY(40px)' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
};

const CARD_MENU: Partial<MenuProps> = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
};

/**
 * The Menu props of a row menu at `placement`. `cardPaper` is the class of a
 * card menu's paper: the caller's `mobile-card-menu-paper` rule, which puts
 * every item's label on one edge.
 */
export const rowMenuProps = (placement: RowMenuPlacement, cardPaper?: string): Partial<MenuProps> =>
  placement === 'card'
    ? { ...CARD_MENU, ...(cardPaper && { classes: { paper: cardPaper } }) }
    : ROW_MENU;
